import React, { useState } from 'react';
import Table from 'react-bootstrap/Table';
import { CSVLink } from 'react-csv';
import { Link } from 'react-router-dom';

import K2Api from 'lib/ajax/K2Api';
import { useK2Loader } from 'hooks/useK2Loader';
import Loader from 'components/Loader';
import UploadCSV from 'components/LM/common/UploadCSV';
import Breadcrumb from "components/LM/common/Breadcrumb";

const k2Api = new K2Api();
function EdiUpload() {
	const [file, setFile] = useState(null);

	const [uploading, setUploading] = useState(false);
	const [success, setSuccess] = useState(false);
	const [error, setError] = useState(null);

	const [loadingLabels, labelsResponse] = useK2Loader('/labels');
	if (loadingLabels) return <Loader />;

	const labels = labelsResponse.map(label => label.name);

	const onSubmit = async () => {
		setError(null);
		const formData = new FormData();
		formData.append('file', file);
		setUploading(true);
		k2Api.post("/voices/import", formData)
			.then(() => {
				setSuccess(true)
			}).catch((error) => {
				setError(error.response.data.errors[0]);
			}).finally(() => setUploading(false))
	}

	const onSetFile = (file) => {
		setSuccess(false);
		setError(null);
		setFile(file);
	}

	const breadcrumbPage = <Breadcrumb items={['Voices', 'Mass Import']} />;

	return (
		<UploadCSV breadcrumb={breadcrumbPage} onSubmit={onSubmit} onSetFile={onSetFile} file={file} importStatusLink={"/voices/import/status"} submitStatus={{ uploading, success, error }} deprecated={<>This importer is no longer available. Please use the <Link to="/voices/new-import">new Mass Import</Link> to upload your file.</>}>
			<>
				<p>The first row indicates the column contents, the process will read these names in order to get the contents</p>
				<p>The accepted column names are:</p>
				<Table striped bordered>
					<thead>
						<tr>
							<th>Column name</th>
							<th>Note</th>
						</tr>
					</thead>
					<tbody>
						<tr><td>id</td><td>voice Id</td></tr>
						<tr><td>name</td><td>name of the voice</td></tr>
						<tr><td>type</td><td>allowed values are:<br /> media, brand, influencer, celebrity</td></tr>
						<tr><td>country_iso</td><td>two letters country code uppercase e.g.   GB, FR, ES, IT….</td></tr>
						<tr><td>label</td><td>allowed values are: <br />{labels.join(', ')}</td></tr>
						<tr><td>online_media</td><td>online media id</td></tr>
						<tr><td>print_media</td><td>print media id</td></tr>
						<tr><td>twitter</td><td>profile url</td></tr>
						<tr><td>facebook</td><td>profile url</td></tr>
						<tr><td>instagram</td><td>profile url</td></tr>
						<tr><td>youtube</td><td>profile url</td></tr>
						<tr><td>tiktok</td><td>profile url</td></tr>
						<tr><td>xiaohongshu (LittleRedBook)</td><td>profile url</td></tr>
						<tr><td>douyin</td><td>profile url</td></tr>
						<tr><td>weibo</td><td>profile url</td></tr>
						<tr><td>wechat_public</td><td>profile url</td></tr>
						<tr><td>bilibili</td><td>profile url</td></tr>
					</tbody>
				</Table>

				<p>You can download an <SampleDownload /> to use as a template</p>
				<br />
				<h4>How does it work</h4>
				<p>With this feature, you can import new voices or update the existing ones</p>

				<ul>
					<li>New Voice</li>
					<ul>
						<li>name <span className="text-danger">*</span></li>
						<li>one of profile_url <span className="text-danger">*</span></li>
						<li>type <span className="text-danger">*</span></li>
						<li>country_iso <span className="text-danger">*</span></li>
						<li>label</li>
					</ul>
				</ul>

				<ul>
					<li>Update Voice</li>
					<ul>
						<li>id <span className="text-danger">*</span></li>
						<li>one of profile_url <span className="text-danger">*</span></li>
						<li>name</li>
						<li>type</li>
						<li>country_iso</li>
						<li>label</li>
					</ul>
				</ul>

				<p><span className="text-danger">*</span> Mandatory field</p>
				<br />
				<h4>FAQ</h4>
				<p><b>Can I use the same file to update the existing voices and for adding new ones? </b>

					Yes, it's not necessary to split in two CSV.
				</p>

				<p><b>I have to update the country for 1000 voices, but I have only the Instagram URL. Do I have to fill type and label? </b>

					No, it's not needed! You can leave empty the column that you don't want to update.</p>

				<p><b>I need to insert the TikTok profiles for 500 voices, but I have only the voice name! Can I do it? </b>

					No, with the voice name, it’s easy to create duplicates. You need the <b>id</b> or one of the existing profile URLs.
				</p>
			</>
		</UploadCSV>
	);
}

function SampleDownload() {
	const data = ['id', 'name', 'country_iso', 'label', 'type', 'online_media', 'print_media', 'twitter', 'facebook', 'instagram', 'youtube', 'tiktok', 'xiaohongshu', 'douyin', 'weibo', 'wechat_public', 'bilibili'];
	return <CSVLink data={[data]} separator={","} filename={"voices_example.csv"}>example</CSVLink>
}

export default EdiUpload;
